import { ArtData } from '@/database/art'
import React, { ReactElement } from 'react'
import { ClaimData } from '@/database/claim'
import { Tooltip } from 'react-tooltip'

const ClaimsReceivedTooltip = ({ artData }: { artData: ArtData }): ReactElement => {
    return (
        <Tooltip anchorSelect={'#claims-received' + artData.art.id} clickable>
            <div>
                {artData.claims
                    .filter((claimData) => claimData.targetArt.nft.tokenId === artData.tokenId)
                    .map((claimData: ClaimData) => (
                        <p key={'#p-claims-received-' + claimData.claim.id}>
                            #{claimData.claim.castingArt.nft.tokenId}
                            <span className="gray">&nbsp;claims&nbsp;</span>
                            {parseFloat(claimData.claim.amount).toFixed(2)}
                        </p>
                    ))}
            </div>
        </Tooltip>
    )
}

export default ClaimsReceivedTooltip
